import { ChangeEvent, useEffect, useState } from "react";
import CardHeaderBackgroundComponent from "../../../../components/cardHeaderBackground";
import ContainerComponent from "../../../../components/conatiner";
import HeaderComponent from "../../../../components/header";
import InputComponent from "../../../../components/input";
import TableComponent from "../../../../components/table";
import { ApproversOrdersService } from "../../../../services/approvers";
import { ToastErro } from "../../../../components/toast";
import moment from "moment";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useNavigate } from "react-router-dom";
import BusinessCardBadgeComponent from "../../../../components/businessCardBadge";

const ApproversAllOrdersPage = () => {

    const [loading, setLoading] = useState<boolean>(true);

    const navigate = useNavigate();

    const [orders, setOrders] = useState<any>([]);

    // variaveis de pesquisa
    const [number, setNumber] = useState<string>('');
    const [name, setName] = useState<string>('');
    const [date, setDate] = useState<string>('');
    const [status, setStatus] = useState<string>('');
    const [page, setPage] = useState<number>(1);
    // variaveis de pesquisa

    // função para pesquisar ordens
    const getOrders = async () => {

        setLoading(true);

        await ApproversOrdersService(number, date, status, page, name).then(resp => {
            setOrders(resp.data);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoading(false);

    }
    // função para pesquisar ordens

    useEffect(() => {
        getOrders();
    }, [page]);

    return (
        <>
            <HeaderComponent
                title="Todas as Ordens"
                button="Filtros"
                iconButton="filter"
                onClick={() => (window as any).$("#modalCreate").modal('show')}
            />
            <ContainerComponent>
                <>
                    <CardHeaderBackgroundComponent
                        title="Pesquisar"
                    >
                        <div className="row">
                            <InputComponent
                                label="N° da Ordem"
                                col={1}
                                size={"small"}
                                defaultValue={number}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => setNumber(e.target.value)}
                                type={'number'}
                            />
                            <InputComponent
                                label="Nome"
                                col={3}
                                size={"small"}
                                defaultValue={name}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
                                type={'text'}
                            />
                            <InputComponent
                                label="Data de Cadstro"
                                col={2}
                                size={"small"}
                                type={'date'}
                                defaultValue={date}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => setDate(e.target.value)}
                                shrink
                            />
                            <div className="col-md-3 mb-4">
                                <FormControl
                                    fullWidth
                                    size="small"
                                >
                                    <InputLabel>Status</InputLabel>
                                    <Select
                                        label="Status"
                                        value={status}
                                        onChange={(e: any) => setStatus(e.target.value)}
                                    >
                                        <MenuItem value={2}>Pago</MenuItem>
                                        <MenuItem value={3}>Pendente de Aprovação</MenuItem>
                                        <MenuItem value={7}>Pendnete de Pagamento</MenuItem>
                                        <MenuItem value={4}>Reprovado</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="col-md-3">
                                <button className="btn btn-primary" type="button" onClick={() => page > 1 ? setPage(1) : getOrders()}>Pesquisar</button>
                                <button className="btn btn-danger" type="button" style={{ marginLeft: 15 }} onClick={() => (window as any).location.reload()}>Limpar</button>
                            </div>
                        </div>
                    </CardHeaderBackgroundComponent>

                    <TableComponent
                        title="Ordens"
                        columns={['Nº da Ordem', 'Data de Cadastrdo', 'Usuário', 'Centro de Custo', 'Valor Total', 'Status', 'Nível de Aprovação', 'Qtd. de Níveis', 'Cartão Corporativo', 'Informações']}
                        loading={loading}
                        page={page}
                        last_page={orders?.last_page}
                        onClickPagination={(e: ChangeEvent<unknown>, value: number) => setPage(value)}
                    >
                        {
                            orders?.data?.map((o: any) => {
                                return (
                                    <tr key={o.id}>
                                        <td className="px-4">{o.id}</td>
                                        <td className="px-4">{moment(o.created_at).format('DD/MM/YYYY')}</td>
                                        <td className="px-4">{o.name}</td>
                                        <td className="px-4">{o.cost_center}</td>
                                        <td className="px-4">{parseFloat(o.total_value ?? 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                        <td className="px-4">
                                            {
                                                o.status == 'Aprovado'

                                                    ?

                                                    <h6><span className="badge bg-info">{o.status}</span></h6>

                                                    :

                                                    o.status == 'Pago'

                                                        ?

                                                        <h6><span className="badge bg-success">{o.status}</span></h6>

                                                        :

                                                        o.status == 'Pendente de Aprovação'

                                                            ?

                                                            <h6><span className="badge bg-warning">{o.status}</span></h6>

                                                            :

                                                            o.status == 'Pendente de Pagamento'

                                                                ?

                                                                <h6><span className="badge bg-info">{o.status}</span></h6>

                                                                :

                                                                <h6><span className="badge bg-danger">{o.status}</span></h6>
                                            }
                                        </td>
                                        <td className="px-4">{o.level}</td>
                                        <td className="px-4">{o.approval_levels}</td>
                                        <td className="px-4">
                                            <BusinessCardBadgeComponent value={o.payment_business_card} />
                                        </td>
                                        <td className="px-4">
                                            <button className="btn btn-text-info" type="button" title="Informações" onClick={() => navigate(`/approvers/orders/${o.id}`)}><i className="material-icons">info</i></button>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </TableComponent>
                </>
            </ContainerComponent>
        </>
    );

}

export default ApproversAllOrdersPage;